
import { Component, Emit, Prop, Vue } from 'vue-property-decorator'
import { MutationOptions } from 'apollo-client'
import { CartBundlesWrap } from '@mg/micro/vue2/CartBundlesWrap'
import type {
  CartBundlesWrapArticle,
  CartBundlesWrapBundleItem,
  CartBundlesWrapDigitalItem,
} from '@mg/micro/vue2/CartBundlesWrap'

import {
  GQL_LOCAL_MUTATION_DELETE_DIGITAL_CART,
  GQL_LOCAL_MUTATION_DELETE_INSURANCE_CART,
  GQL_LOCAL_MUTATION_DELETE_WARRANTY_CART,
  GQL_LOCAL_MUTATION_RETURN_GUARANTEE_CART,
} from '~/graphql/gqlLocal/localCart'
import {
  GQLLocalCart,
  GQLLocalCartArticle,
  GQLLocalMutationDeleteCartInsuranceArgs,
  GQLLocalMutationDeleteCartWarrantyArgs,
} from '~/graphql/__generated__/interfacesLocal'

@Component({
  components: { CartBundlesWrap },
})
export default class HeaderCartBundlesWrap extends Vue {
  @Prop(String) cartId!: GQLLocalCart['id']
  @Prop(Object)
  cartArticle!: GQLLocalCartArticle

  setDataSel(id: string) {
    return `product-services-widget-${id}`
  }

  get cartArticleForMicro(): CartBundlesWrapArticle {
    const { count, variants, bundles } = this.cartArticle

    return {
      count,
      variants:
        variants?.map((variant) => ({
          ...variant,
          variantId: Number(variant.variantId),
        })) ?? undefined,
      bundles: {
        digital: bundles.digital
          .filter((digital) => digital?.id)
          .map((digital) => ({
            ...digital,
            variantId: Number(digital.variantId),
            title: this.$t('common.cart_' + digital.itemId) as string,
            dataSel: this.setDataSel(digital.itemId),
          })),
        warranty: bundles.warranty
          .filter((warranty) => warranty?.id)
          .map((warranty) => ({
            ...warranty,
            variantId: Number(warranty.variantId),
            title: this.$t('common.' + warranty.itemId) as string,
            dataSel: this.setDataSel(warranty.id),
          })),
        insurance: bundles.insurance
          .filter((insurance) => insurance?.id)
          .map((insurance) => ({
            ...insurance,
            variantId: Number(insurance.variantId),
            title: this.$t('common.' + insurance.itemId) as string,
            dataSel: this.setDataSel(insurance.id),
          })),
        returnGuarantee: bundles.returnGuarantee
          .filter((returnGuarantee) => returnGuarantee?.id)
          .map((returnGuarantee) => ({
            ...returnGuarantee,
            variantId: Number(returnGuarantee.variantId),
            title: this.$t('common.cart_' + returnGuarantee.itemId) as string,
            dataSel: this.setDataSel(returnGuarantee.id),
          })),
      },
    }
  }

  @Emit('apolloMutationCart')
  apolloMutationCart(data: {
    apolloMutation: MutationOptions
    articleId: GQLLocalCartArticle['articleId']
  }) {
    return data
  }

  deleteDigital(digital: CartBundlesWrapDigitalItem) {
    this.apolloMutationCart({
      apolloMutation: {
        mutation: GQL_LOCAL_MUTATION_DELETE_DIGITAL_CART,
        variables: {
          bundleId: this.cartArticle.articleId,
          cartId: this.cartId,
          id: digital.itemId,
        },
      },
      articleId: this.cartArticle.articleId,
    })
  }

  deleteWarranty(warranty: CartBundlesWrapBundleItem) {
    this.apolloMutationCart({
      apolloMutation: {
        mutation: GQL_LOCAL_MUTATION_DELETE_WARRANTY_CART,
        variables: {
          articleId: this.cartArticle.articleId,
          cartId: this.cartId,
          variantId: String(warranty.variantId),
        } as GQLLocalMutationDeleteCartWarrantyArgs,
      },
      articleId: this.cartArticle.articleId,
    })
  }

  deleteInsurance(insurance: CartBundlesWrapBundleItem) {
    this.apolloMutationCart({
      apolloMutation: {
        mutation: GQL_LOCAL_MUTATION_DELETE_INSURANCE_CART,
        variables: {
          articleId: this.cartArticle.articleId,
          cartId: this.cartId,
          variantId: String(insurance.variantId),
        } as GQLLocalMutationDeleteCartInsuranceArgs,
      },
      articleId: this.cartArticle.articleId,
    })
  }

  deleteReturnGuarantee(returnGuarantee: CartBundlesWrapBundleItem) {
    this.apolloMutationCart({
      apolloMutation: {
        mutation: GQL_LOCAL_MUTATION_RETURN_GUARANTEE_CART,
        variables: {
          articleId: this.cartArticle.articleId,
          cartId: this.cartId,
          variantId: String(returnGuarantee.variantId),
        } as GQLLocalMutationDeleteCartInsuranceArgs,
      },
      articleId: this.cartArticle.articleId,
    })
  }
}
